export const MAX_PROMPT_SIZE = 10_000
